import * as ENV from "@/config.js";

/** Facility slug that uses the events child-seat booking app and promo assets. */
const EVENTS_BOOKING_FACILITY = "events";

/**
 * True when this build is for the events facility (child seat / showground flow).
 * Used to show promo imagery only on events deployments, not other facilities.
 */
export function isEventsBookingFacility() {
  return String(ENV.VUE_APP_FACILITY || "").toLowerCase() === EVENTS_BOOKING_FACILITY;
}

/** Form header banner (child seat booking page). */
export const EVENTS_CHILD_SEAT_FORM_HEADER_IMAGE_URL =
  "https://www.fairfieldcity.nsw.gov.au/files/assets/public/v/1/images/it-external-booking-app/screenshot-2026-05-12-141759.png";

/** Form footer banner (child seat booking page). */
export const EVENTS_CHILD_SEAT_FORM_FOOTER_IMAGE_URL =
  "https://www.fairfieldcity.nsw.gov.au/files/assets/public/v/1/images/it-external-booking-app/screenshot-2026-05-12-141454.png";

/** Destination when the form footer banner is clicked (child restraint information). */
export const EVENTS_CHILD_SEAT_FORM_FOOTER_LINK_URL =
  "https://www.childcarseats.com.au/";

/** Corner logo (events child-seat booking page, top-left of form card). */
export const EVENTS_FORM_CORNER_LOGO_URL =
  "https://dashboard.fairfieldcity.nsw.gov.au/bookingapp/events/adminmodule/img/FairfieldCouncil.0933bbfb.svg";
